import clsx from 'clsx';
import { memo } from 'react';
import styles from './styles.module.css';

// Tô đậm các đoạn [start, end) do BE trả về (chỉ số code point trên chuỗi NFC)
function HighlightText({ text = '', ranges = [], className = '' }) {
  if (!text || !ranges?.length) {
    return text;
  }
  const chars = Array.from(text.normalize('NFC'));
  const parts = [];
  let start = 0;
  ranges.forEach(([from, to]) => {
    if (from > start) {
      parts.push(chars.slice(start, from).join(''));
    }
    parts.push(
      <span key={from} className={clsx(styles.highlight, className)}>
        {chars.slice(from, to).join('')}
      </span>,
    );
    start = to;
  });
  if (start < chars.length) {
    parts.push(chars.slice(start).join(''));
  }
  return parts;
}

export default memo(HighlightText);
